module.exports = __webpack_public_path__ + "img/—Pngtree—vector happy icon_4277917@2x.b55b58fa.png";